import styled from 'styled-components';
import { borderRadius, colourPalette, gap, hexToRGBA, padding } from 'styles/styles';

export const BadgeStyle = {
  Container: styled.div<{
    $bgColor?: keyof typeof colourPalette;
    $bgColorAlpha?: number;
    $isClickable?: boolean;
    $radius?: keyof typeof borderRadius;
  }>`
    display: inline-flex;
    gap: ${gap.gap1};
    min-height: 24px;
    padding: ${padding.paddingXXS} ${padding.paddingSM};
    justify-content: center;
    align-items: center;
    border-radius: ${({ $radius }) => ($radius ? borderRadius[$radius] : borderRadius.roundedSM)};
    background-color: ${({ $bgColor, $bgColorAlpha }) =>
      $bgColor
        ? $bgColorAlpha
          ? hexToRGBA(colourPalette[$bgColor], $bgColorAlpha)
          : colourPalette[$bgColor]
        : colourPalette.neutral100};
    ${({ $isClickable }) => $isClickable && `cursor: pointer;`}
    .badge-label {
      line-height: ${gap.gap4};
    }
  `,
};
